import Vue from "vue";
import Vuex from "vuex";
import user from "./user";
import userInterface from "./interface";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    userInterface
  }
});

export default store;
